import EditTopicFormContainer from './EditTopicFormContainer';
import GetTopic from './services/GetTopic';
import EditTopic from './services/EditTopic';
import stores from './stores';

const EditTopicForm = {
  path: ['/edit-topic/'],
  exact: false,
  services: [new GetTopic(), new EditTopic()],
  stores: stores,
  component: EditTopicFormContainer
};

export default EditTopicForm;
